var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('h3',[_vm._v("QWERTY 键盘布局 + 字母记忆游戏")]),_c('h5',[_vm._v("从 A 到 Z 依次按下字母即可")]),_c('schulte-grid')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }